(function () {
  'use strict';

  if (customElements.get('skafe-sticky-atc')) return;

  class SkafeStickyAtc extends HTMLElement {
    connectedCallback() {
      const sectionId = this.dataset.sectionId;
      this.primaryButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
      this.priceRoot = document.getElementById(`price-${sectionId}`);
      this.priceTarget = this.querySelector('[data-sticky-atc-price]');
      this.stickyButton = this.querySelector('[data-sticky-atc-button]');
      this.hasSeenPrimaryButton = false;

      if (!this.primaryButton || !this.stickyButton) return;

      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) this.hasSeenPrimaryButton = true;
        this.sync();
      });
      this.visibilityObserver.observe(this.primaryButton);

      this.stateObserver = new MutationObserver(() => this.sync());
      this.stateObserver.observe(this.primaryButton, { attributes: true, childList: true, subtree: true });
      if (this.priceRoot) {
        this.stateObserver.observe(this.priceRoot, { childList: true, subtree: true, characterData: true });
      }

      this.sync();
    }

    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
      this.stateObserver?.disconnect();
    }

    sync() {
      if (!this.primaryButton || !this.stickyButton) return;

      const primaryBounds = this.primaryButton.getBoundingClientRect();
      const primaryHasPassed = this.hasSeenPrimaryButton && primaryBounds.bottom <= 0;
      const available = !this.primaryButton.disabled;
      this.stickyButton.disabled = !available;

      if (this.priceRoot && this.priceTarget) {
        const price = this.priceRoot.querySelector('.price');
        if (price) this.priceTarget.innerHTML = price.outerHTML;
      }

      this.hidden = !(primaryHasPassed && available && window.matchMedia('(max-width: 749px)').matches);
    }
  }

  customElements.define('skafe-sticky-atc', SkafeStickyAtc);
})();
